import { takeLatest, all } from "redux-saga/effects";

import {
  handleGetNewPartRequests,
  handleGetPartRequestsByState,
  handleGetPartRequestDetails,
} from "./handlers/partRequest";

import { handleGetPartOffer, handleReadPartOffer } from "./handlers/partOffers";
import { handleGetUserFilters } from "./handlers/userFIlter";

import {
  getAllPartRequest,
  getNewPartRequests,
  getActivePartRequests,
  getCompletedPartRequests,
  getArchivedPartRequests,
  getPartRequestDetails,
  getPartRequests,
} from "../entities/partRequest";

import { getPartOffer, getSinglePartOffer } from "../entities/partOffers";
import { getUserFilters } from "../entities/userFilters";

import {
  getUserFiltersData,
  deleteUserFilterByMake,
  saveUserFiltersData,
} from "../entities/userFiltersStore";

import {
  handleGetUserFiltersData,
  handleDeleteUserFilter,
  handleSaveUserFilters,
} from "./handlers/userFiltersStore";

import { getStoreData } from "../entities/userFIlterStore";
import { handleFetchData } from "./handlers/userFilterStore";
import {
  handleGetSellerActiveRequestsMessages,
  handleGetSellerOtherMessages,
  handleGetPartRequestMessages,
  handleSendMessage
} from "./handlers/messages";
import { getActiveRequestsMessages, getOtherMessages, getPartRequestMessages, sendMessage } from "../entities/messages";
import { getSettingsConfig } from "../entities/configs";
import { handleGetSettingsConfig } from "./handlers/configs";
import { getAddresses, createAddress } from "../entities/addresses";
import { handleGetAddresses, handleCreateAddress } from "./handlers/addresses";

export function* watcherSaga() {
  yield all([
    takeLatest(getNewPartRequests.type, handleGetNewPartRequests),
    takeLatest(getAllPartRequest.type, handleGetPartRequestsByState),
    takeLatest(getActivePartRequests.type, handleGetPartRequestsByState),
    takeLatest(getCompletedPartRequests.type, handleGetPartRequestsByState),
    takeLatest(getArchivedPartRequests.type, handleGetPartRequestsByState),
    takeLatest(getPartRequestDetails.type, handleGetPartRequestDetails),
    takeLatest(getPartOffer.type, handleGetPartOffer),
    takeLatest(getUserFilters.type, handleGetUserFilters),
    takeLatest(getStoreData.type, handleFetchData),
    takeLatest(getActiveRequestsMessages.type, handleGetSellerActiveRequestsMessages),
    takeLatest(getOtherMessages.type, handleGetSellerOtherMessages),
    takeLatest(getPartRequestMessages.type, handleGetPartRequestMessages),
    takeLatest(getSettingsConfig.type, handleGetSettingsConfig),
    takeLatest(getUserFiltersData.type, handleGetUserFiltersData),
    takeLatest(deleteUserFilterByMake.type, handleDeleteUserFilter),
    takeLatest(saveUserFiltersData.type, handleSaveUserFilters),
    takeLatest(getSinglePartOffer.type, handleReadPartOffer),
    takeLatest(sendMessage.type, handleSendMessage),
    takeLatest(getAddresses.type, handleGetAddresses),
    takeLatest(createAddress.type, handleCreateAddress),
  ]);
}
